var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHisEditIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 14.25H4.69613L12.3735 6.57262L11.4274 5.6265L3.75 13.3039V14.25ZM2.625 15.375V12.8366L12.5179 2.94806C12.6313 2.84506 12.7564 2.7655 12.8934 2.70938C13.0306 2.65313 13.1743 2.625 13.3247 2.625C13.4751 2.625 13.6207 2.65169 13.7616 2.70506C13.9026 2.75844 14.0274 2.84331 14.136 2.95969L15.0519 3.88706C15.1683 3.99569 15.2513 4.12069 15.3007 4.26206C15.3503 4.40344 15.375 4.54481 15.375 4.68619C15.375 4.83706 15.3493 4.981 15.2978 5.118C15.2463 5.25513 15.1643 5.38038 15.0519 5.49375L5.16338 15.375H2.625ZM11.8922 6.10781L11.4274 5.6265L12.3735 6.57262L11.8922 6.10781Z",
    fill: "#323848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHisEditIc);
export default __webpack_public_path__ + "static/media/his_edit_ic.0387120b35247bdd22a392416b6c3dd9.svg";
export { ForwardRef as ReactComponent };